export default {
  paged: {
    select:
      'id,isActive,order,name,ownerUserId,powerBIReportGroupId,powerBIServerConfigurationId',
    searchSelect: ['name', 'powerBIReportGroupId'],
    orderBy: 'order',
    expand: {
      powerBIServerConfiguration: { select: 'id,name' },
    },
  },
  item: {
    select:
      'id,isActive,order,name,ownerUserId,powerBIReportGroupId,powerBIServerConfigurationId,permissionsFiltersLogicalOperator,accessControl',
    expand: {
      powerBIServerConfiguration: { select: 'id,name' },
      ownerUser: { select: 'id,fullName' },
    },
  },
  itemDetail: {
    select:
      'id,isActive,order,name,powerBIReportGroupId,permissionsFiltersLogicalOperator,ownerUserId,created,updated,creator,modifier',
    expand: {
      powerBIServerConfiguration: { select: 'id,name' },
      ownerUser: { select: 'id,fullName' },
    },
  },
};
